const map = {
	"./en-takeda-privacy-policy.html": "./src/locales/takeda/privacy-policy/en-takeda-privacy-policy.html",
	"./ja-takeda-privacy-policy.html": "./src/locales/takeda/privacy-policy/ja-takeda-privacy-policy.html"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales/takeda/privacy-policy sync recursive ^\\.\\/.*\\-takeda\\-privacy\\-policy\\.html$";